// libs
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getListRewardsRequest: ['params'],
  getListRewardsSuccess: ['data'],
  getListRewardsFailed: ['error']
});
